/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Move_Link_TakenInputs */

const en_error_crm_move_link_taken = /** @type {(inputs: Error_Crm_Move_Link_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone already took the personal link of this person for this campaign.`)
};

/**
* | output |
* | --- |
* | "Someone already took the personal link of this person for this campaign." |
*
* @param {Error_Crm_Move_Link_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_move_link_taken = /** @type {((inputs?: Error_Crm_Move_Link_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Move_Link_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_move_link_taken(inputs)
});